import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

interface FullscreenLoadingContextValue {
  isFullscreenLoading: boolean;
  setFullscreenLoading: (active: boolean) => void;
}

const FullscreenLoadingContext = createContext<FullscreenLoadingContextValue>({
  isFullscreenLoading: false,
  setFullscreenLoading: () => {},
});

export const useFullscreenLoading = () => useContext(FullscreenLoadingContext);

export const FullscreenLoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isFullscreenLoading, setIsFullscreenLoading] = useState(false);

  const setFullscreenLoading = useCallback((active: boolean) => {
    setIsFullscreenLoading(active);
  }, []);

  const value = useMemo(() => ({
    isFullscreenLoading,
    setFullscreenLoading,
  }), [isFullscreenLoading, setFullscreenLoading]);

  return (
    <FullscreenLoadingContext.Provider value={value}>
      {children}
    </FullscreenLoadingContext.Provider>
  );
};
